import React from 'react';
import { Link } from 'react-router-dom';
import BigValueLogo from '../common/BigValueLogo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 회사 정보 */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <BigValueLogo width={28} height={28} />
              <h3 className="text-white text-xl font-bold">빅밸류</h3>
            </div>
            <p className="text-sm mb-4 text-gray-400">
              당신의 분석 여정을 단순하게,<br />
              결과는 풍부하게
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* API 문서 */}
          <div>
            <h4 className="text-white font-semibold mb-4">API 문서</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/api-docs/realestate" className="hover:text-white">부동산 데이터</Link></li>
              <li><Link to="/api-docs/business" className="hover:text-white">사업자 데이터</Link></li>
              <li><Link to="/api-docs/card" className="hover:text-white">카드 데이터</Link></li>
              <li><Link to="/api-docs/authentication" className="hover:text-white">인증 가이드</Link></li>
            </ul>
          </div>

          {/* 개발자 도구 */}
          <div>
            <h4 className="text-white font-semibold mb-4">개발자 도구</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/developer-tools/api-test" className="hover:text-white">API 테스트 콘솔</Link></li>
              <li><Link to="/developer-tools/sandbox" className="hover:text-white">샌드박스 환경</Link></li>
              <li><Link to="/developer-tools/sdk" className="hover:text-white">SDK 다운로드</Link></li>
              <li><Link to="/developer-tools/code-samples" className="hover:text-white">코드 샘플</Link></li>
            </ul>
          </div>

          {/* 지원 */}
          <div>
            <h4 className="text-white font-semibold mb-4">지원</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/support/getting-started" className="hover:text-white">시작하기</Link></li>
              <li><Link to="/support/faq" className="hover:text-white">FAQ</Link></li>
              <li><Link to="/support/community" className="hover:text-white">커뮤니티</Link></li>
              <li><Link to="/support/contact" className="hover:text-white">문의하기</Link></li>
              <li><Link to="/pricing" className="hover:text-white">요금제</Link></li>
            </ul>
          </div>
        </div>

        {/* 하단 정보 */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © 2025 빅밸류(BigValue). All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/terms" className="text-sm text-gray-400 hover:text-white">이용약관</Link>
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-white">개인정보처리방침</Link>
              <Link to="/security" className="text-sm text-gray-400 hover:text-white">보안정책</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
